import { useSelector } from 'react-redux';
import LoadingAnimation from '../../componets/loader/loader';
import { API } from '../../config/api';
import { GET, PUT } from '../../utils/apicalls';
import { Button, Card, Form, Input, notification, Switch } from 'antd';
import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';

function ClientProfile() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state: any) => state.user); // Correctly access user state
  const [form] = Form.useForm();

  const fetchOneClient = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(`${API.FIND_ONE_CLIENT_DATA}${user.id}`, {});
      setData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        clientType: "client",
        clientName: values.clientName,
        clientEmail: values.clientEmail,
        clientAddress: values.clientAddress,
        clientPhoneNumber: values.clientPhoneNumber,
        clientAltphone: values.clientAltphone,
        clientUsername: values.clientUsername,
        clientPassword: values.clientPassword,
        status: values.status,
      };

      setIsLoading(true);
      let api = API.UPDATE_CLIENT_DATA + user.id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest.status) {
        notification.success({
          message: "details updated successfully!",
        });
        form.resetFields();
        fetchOneClient();

      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOneClient();
  }, []);



  return (
    <div>

      {isLoading && !data ? (
        <LoadingAnimation />
      ) : (
        <Card
          title="Edit Client Details"
          bordered={false}
          style={{
            maxWidth: 700,
            margin: "auto",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "20px",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={UpdateHandler}
            initialValues={data}
            style={{ padding: "10px" }}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Client Name"
                  name="clientName"
                  rules={[{ required: true, message: "Please enter client name" }]}
                >
                  <Input placeholder="Enter client name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Email"
                  name="clientEmail"
                  rules={[
                    { required: true, message: "Please enter email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input placeholder="Enter client email" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Phone Number" name="clientPhoneNumber">
                  <Input placeholder="Enter phone number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Alt Phone" name="clientAltphone">
                  <Input placeholder="Enter alternative phone" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Username" name="clientUsername">
                  <Input placeholder="Enter username" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Password"
                  name="clientPassword"
                  rules={[{ required: true, message: "Please enter a password" }]}
                >
                  <Input.Password placeholder="Enter new password" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="Address" name="clientAddress">
                  <Input.TextArea placeholder="Enter client address" autoSize={{ minRows: 3, maxRows: 5 }} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16} align="middle">
              <Col span={12}>
                <Form.Item label="Status" name="status" valuePropName="checked">
                  <Switch checkedChildren="Enabled" unCheckedChildren="Disabled" disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    style={{
                      backgroundColor: "#1890ff",
                      borderRadius: "6px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      height: "40px",
                    }}
                  >
                    Update Client
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
    </div>
  )
}

export default ClientProfile
